import { Component, ElementRef, HostListener, inject, Input } from "@angular/core";
import { Store, Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { ConfirmationModalComponent } from "../../../widgets/modal/confirmation-modal/confirmation-modal.component";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MatIconModule } from "@angular/material/icon";
import { AuthState } from "src/app/core/auth/state/auth.state";
import { Logout } from "src/app/core/auth/state/auth.action";
import { AccountState } from "src/app/core/account/state/account.state";
import { Account, Streamer } from "src/app/core/account/model/account.model";
import { MatDialog } from "@angular/material/dialog";
import { DsButtonComponent } from "src/app/ui/design-system/button/button.component";

@Component({
  standalone: true,
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
  imports: [
    DsButtonComponent,
    CommonModule,
    RouterModule,
    TranslateModule,
    MatIconModule]})
export class MyAccountComponent {
  @Input() style: string = "basic";
  public isMenuOpen = false;

  @Select(AuthState.isAuthenticated) isAuthenticated$: Observable<string>;
  @Select(AccountState.account) account$: Observable<Account>;
  @Select(AccountState.streamer) streamer$: Observable<Streamer>;
  @Select(AccountState.accountType) accountType$: Observable<string>;

  dialog = inject(MatDialog);
  private readonly hostRef = inject(ElementRef<HTMLElement>);

  constructor(
    private _store: Store,
    private _router: Router,
  ) {}

  openLogoutDialog() {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: "460px",
      maxWidth: "92vw",
      panelClass: ["confirmation-modal-panel"],
      backdropClass: ["confirmation-modal-backdrop"]});

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.logout();
      }
    });
  }

  toggleAccountMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node | null;
    if (!target) {
      return;
    }

    if (!this.hostRef.nativeElement.contains(target)) {
      this.closeMenu();
    }
  }

  logout() {
    this._store.dispatch(new Logout()).subscribe({});

    this._router.navigateByUrl("/auth/login");
  }
}
